import { render, staticRenderFns } from "./list-visit.vue?vue&type=template&id=60db6e29"
import script from "./list-visit.vue?vue&type=script&lang=js"
export * from "./list-visit.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/list/list.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports